import { useMemo } from 'react';
import clsx from 'clsx';

import { useSchemas } from '@atom/hooks/useSchemas';
import { numberToLocaleString } from '@atom/utilities/currencyUtility';

import { ReportMaterial } from './reportUtilities';

import classes from './workOrderReport.module.css';

interface Props {
  reportMaterial: ReportMaterial;
  isCompletedOrAbove: boolean;
}

const ReportUsageRow = ({ reportMaterial, isCompletedOrAbove }: Props) => {
  const { schemas = [] } = useSchemas();

  const schema = useMemo(() => {
    return schemas.find(({ id }) => id === reportMaterial.schemaId);
  }, [schemas, reportMaterial.schemaId]);

  const amount = reportMaterial?.entries.reduce((acc, entry) => {
    return acc + entry?.amount || 0;
  }, 0);

  const name = reportMaterial?.unit
    ? `${reportMaterial?.name} (${reportMaterial?.unit.toUpperCase()})`
    : reportMaterial?.name;

  return (
    <div className={classes.materialRow}>
      <div className={classes.materialType}>{schema?.name || ''}</div>
      <div className={classes.materialName}>{name}</div>
      <div className={classes.materialRowSub}>
        <div className={clsx(classes.materialValue, classes.used)}>
          {amount || ''}
        </div>
        {isCompletedOrAbove && (
          <div className={classes.materialValue}>
            {reportMaterial?.rate && amount
              ? numberToLocaleString(reportMaterial?.rate * amount)
              : ''}
          </div>
        )}
      </div>
    </div>
  );
};

export default ReportUsageRow;
